import { css } from 'styled-system/css';
import { AgentDot } from './AgentDot';

export function ChatLine({
  who,
  body,
  agent,
  right,
}: {
  who: string;
  body: string | readonly string[];
  agent?: boolean;
  right?: boolean;
}) {
  const paragraphs = typeof body === 'string' ? [body] : body;
  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        gap: '1',
        alignItems: right ? 'flex-end' : undefined,
        textAlign: right ? 'right' : undefined,
      })}
    >
      <span
        className={css({
          display: 'inline-flex',
          alignItems: 'center',
          gap: '2',
          fontFamily: 'mono',
          fontSize: '2xs',
          color: 'text.muted',
        })}
      >
        {agent && <AgentDot />}
        {who}
      </span>
      {paragraphs.map((para) => (
        <p
          key={para}
          className={css({
            margin: 0,
            maxWidth: right ? '100%' : undefined,
            fontSize: 'xs',
            lineHeight: 'snug',
            color: 'text.primary',
          })}
        >
          {para}
        </p>
      ))}
    </div>
  );
}
